import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Observable } from 'rxjs';
import { EditManufacturersComponent } from '../edit-manufacturers/edit-manufacturers.component';
import { AdminViewsService } from '../_services/admin-views.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  manufacturers$ = this.adminServices.manufacturers$;
  users$ = this.adminServices.userModification$;
  userForm: FormGroup
  loading: boolean;
  constructor(private adminServices: AdminViewsService, private modalService: BsModalService, private _formBuilder: FormBuilder) { }
  bsModalRef: BsModalRef;
  ngOnInit(): void {
    this.userForm = this._formBuilder.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required,]],
      email: [null, [Validators.required, Validators.email]],
      userName: [null, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(8)]],
      isAdmin: [false, [Validators.required]],
    });

    this.adminServices.getManufacturers().subscribe(res => {
      console.log(res);
    })
  }


  openDialog(id: string) {
    const initialState = {
      id: id,
    };

    this.bsModalRef = this.modalService.show(EditManufacturersComponent, { initialState });
  }

  addUsers() {
    if (!this.userForm.valid)
      return;

    this.adminServices.createUser(this.userForm.value);
  }


  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.userForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  onChangeIsAdmin(event) {
    const usersAssigned = this.userForm.get('isAdmin').value;
    this.userForm.get('isAdmin').patchValue(!usersAssigned);
  }

  deleteUser(userId: string) {
    console.log(userId);
    this.adminServices.deleteUser(userId);
  }
}
